import { render, staticRenderFns } from "./ReminderNumCard.vue?vue&type=template&id=49708da1&scoped=true"
import script from "./ReminderNumCard.vue?vue&type=script&lang=js"
export * from "./ReminderNumCard.vue?vue&type=script&lang=js"
import style0 from "./ReminderNumCard.vue?vue&type=style&index=0&id=49708da1&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49708da1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49708da1')) {
      api.createRecord('49708da1', component.options)
    } else {
      api.reload('49708da1', component.options)
    }
    module.hot.accept("./ReminderNumCard.vue?vue&type=template&id=49708da1&scoped=true", function () {
      api.rerender('49708da1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/ReminderNumCard.vue"
export default component.exports